import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import MarginTradingEHero from "./MarginTradingEHero";
import DesignStartup from "./DesignStartup";
import WeOfferMargin from "./WeOfferMargin";
import OperationalEfficiency from "./OperationalEfficiency";
import WhatisMargin from "./WhatisMargin";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function MarginTradingE() {
  return (
    <div>
      <Header />
      <MarginTradingEHero />
      <WhatisMargin />
      <DesignStartup />
      <OperationalEfficiency />
      <WeOfferMargin />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default MarginTradingE;
